<template>
  <div>
    <div v-if="!info.orderId" class="noOrder">暂无订单</div>
    <div v-else>
      <div class="orderBox">
        <img class="bg" src="../assets/bg.png">
        <div v-if="info.orderStatusText != '退款完成' && info.orderStatusText != '订单完成'" class="takNo">
          <p class="adBtn">取茶码</p>
          <p v-if="info.takeNo" class="textBlood">{{ info.takeNo}}</p>
          <p v-else style="font-size: 18px;margin-top:10px">等待店铺接单,请稍后刷新</p>
        </div>

        <div v-else class="takNo textBlood">{{info.orderStatusText}}</div>
      </div>

      <div class="home">
        <div class="shopBox">

          <div class="border_btm shopInfo">
            <div>
              <p class="shopName webBox">{{ info.shopName }}</p>
              <P class="shopAdd webBox">{{ info.shopAddress }}</P>
            </div>

            <div class="shopIcon" style="margin-left: 22px">
              <div class="iconItem" style="margin-right: 8px" @click="showShopPhone">
                <img src="@/assets/电话.png" alt="">
                <p>电话</p>
              </div>
              <div class="iconItem" @click="goShop">
                <img src="@/assets/导航.png" alt="">
                <p>导航</p>
              </div>
            </div>
          </div>

          <div class="product border_btm">
            <img :src="info.productLogo">
            <!--                <image v-else :src="errImg" mode="aspectFit" style="width: 100px;height: 120px;"></image> -->

            <div class="detail">
              <div class="flex-ad">
                <p style="font-weight: 400;font-size: 14px">{{ info.productName }}</p>
                <p style="font-weight: 600;font-size: 15px">¥{{ info.productPrice }}</p>
              </div>
              <div class="flex-ad">
                <p class="attributeName">
                  {{
                    info.attributeName
                  }}</p>
                  <p style="color: #999;font-size: 13px;margin-top: 4px">x{{ info.productAmount }}</p>
              </div>
            </div>
          </div>

          <div class="juanSec border_btm">
            <p class="flex-ad" style="color: #414141;font-size: 14px;">优惠合计 <span class="truncate">{{info.couponName}}</span></p>
            <p style="font-size: 15px;font-weight: 500">-¥{{ info.productPrice }}</p>
          </div>

          <div class="btm">
            <p style="text-align: right;font-size: 13px">共计1件商品，合计<span
                style="font-size: 19px;font-weight: 600">¥0</span></p>
          </div>

        </div>

        <div class="shopBox" style="margin-top: 13px">
          <p class="info-Top">订单信息</p>
          <div class="item">
            <p>取餐码</p>
            <p class="right">{{ info.takeNo }}</p>
          </div>

          <div class="item">
            <p>备注</p>
            <p class="right">{{ !info.remark ? '无' : info.remark }}</p>
          </div>

          <div class="item">
            <p>下单时间</p>
            <p class="right">{{ info.orderTime }}</p>
          </div>
          <div class="item">
            <p>订单号</p>
            <p class="right">{{ info.orderId }}</p>
          </div>

          <div class="item">
            <p>手机号</p>
            <p class="right">{{ info.mobilePhone }}</p>
          </div>


        </div>

      </div>
    </div>

    <!-- 添加订单提示弹窗 -->
    <el-dialog
        title="门店电话"
        :visible.sync="dialogVisible"
        width="80%"
        :close-on-click-modal="false"
    >
      <span>{{info.shopPhone || '未获取到门店电话'}}</span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
import {queryOrder} from "@/api/cbd";

export default {
  name: 'orderInfo',
  data() {
    return {
      info: {},
      dialogVisible:false
    }
  },
  watch: {
    $route: {
      handler(to, from) {
        if (to.query.cardID) {
          this.cardID = this.$route.query.cardID
          localStorage.setItem('cardID', this.cardID);
        }
      },
      deep: true
    }
  },
  mounted() {
    if (this.$route.query.cardID) {
      this.cardID = this.$route.query.cardID
      localStorage.setItem('cardID', this.cardID);
    }
    if (!localStorage.getItem('cardID')) return this.$message.error('未复制完整卡密链接')
    this.getOrder();
  },
  methods: {
    getOrder() {
      queryOrder({cardID: localStorage.getItem('cardID')}).then(res => {
        if (res.code !== 0) return
        this.info = res.data
        console.log(res, '订单查询返回')
      }).catch(err=>{
        this.$message.error('查询失败,请刷新重试')
      })
    },
    showShopPhone(){
      this.dialogVisible = true;
    },
    goShop(){
      this.$message.error('暂未开放此功能')
    }
  }
}
</script>

<style lang="less" scoped>
.home {
  width: 100%;
  height: calc(100vh);
  padding-top: 13px;
  background-color: #F5F5F5;
  margin: -10px 0 0 0;
  border-radius: 10px 10px 0 0;
  position: relative;
}

.orderBox {
  width: 100%;
  height: 200px;
  position: relative;

  .bg {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .xue {
    width: 140px;
    height: 120px;
    object-fit: cover;
    position: absolute;
    right: 20px;
    bottom: 0;
  }

  .takNo {
    position: absolute;
    left: 20px;
    bottom: 40px;
    //color: #FFFFFF;
  }
  .textBlood{
    font-size: 26px;
    font-weight: 700;
    color: #111;
  }
}


.shopBox {
  width: 85%;
  margin: 0 auto;
  padding: 17px 13px;
  background-color: #FFFFFF;
  border-radius: 13px;
  box-shadow: 0px 8px 12px rgb(135 134 134 / 5%);
  //z-index: 666;
  //height: 300px;
  .shopName{
    color: #111;
    height: 22px;
    line-height: 22px;
    margin-bottom: 5px;
    font-weight: 500;
    font-size: 15px;
  }
  .shopAdd{
    color: #707070;
    height: 18px;
    line-height: 18px;
    font-weight: 400;
    font-size: 13px;
    margin-bottom: 11px;
  }

  .shopInfo{
    display: flex;
    .shopIcon{
      display: flex;
      .iconItem{
        background: #f5f6f7;
        border-radius: 4px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        height: 39px;
        padding-top: 4px;
        width: 45px;
        img{
          width: 18px;
          height: 18px;
        }
        p{
          height: 15px;
          line-height: 15px;
          margin-top: 2px;
          font-size: 11px;
        }
      }
    }
  }
}

.product {
  padding: 13px 0;
  display: flex;
  flex-direction: row;

  img {
    border-radius: 8px;
    width: 55px;
    height: 55px;
    margin-right: 13px;
    object-fit: cover;
  }

  .detail {
    width: calc(100% - 68px);
    .attributeName{
      max-width: 230px;
      margin-top: 4px;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      color: #999;
      display: -webkit-box;
      line-height: 16px;
      overflow: hidden;
      text-overflow: ellipsis;
      word-break: break-all;
      font-size: 12px;
    }
  }

}

.payInfo {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}

.juanSec {
  padding: 10px 0;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

.flex-ad {
  display: flex;
  justify-content: space-between;
  //align-items: center;
}

.btm {
  margin-top: 20px;
}


.item {
  min-height: 44px;
  font-size: 13px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

//.item p:first-child{
//  min-width: 80px;
//  margin-right: 10px;
//  color: #999999;
//}

.right {
  //color: #606060;
}



.juan {
  font-size: 14px;
  border: 1px solid #842A43;
  color: #842A43;
  padding: 3px 5px;
}


.font_L {
  font-size: 13px;
  color: #999999;
}

.border_btm {
  border-bottom: 1px solid #F5F6F7;
}

.noOrder{
  height: 60vh;
  display: flex;
  justify-content: center;
  align-items: center;
}

.truncate {
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  color: #9e9e9e;
  display: -webkit-box;
  height: 19px;
  line-height: 19px;
  margin-right: auto;
  max-width: 152px;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-all;
  margin-left: 11px;
  font-size: 14px;
}

.adBtn {
  display: inline-block;
  padding: 5px 8px;
  font-size: 13px;
  color: #fff;
  background: linear-gradient(to right, #1783FA,#1472FA); /* 渐变背景 */
  border: none;
  border-radius: 20px 20px 0 20px; /* 圆角 */
  //box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1); /* 阴影 */
  //cursor: pointer;
  //transition: all 0.3s ease; /* 过渡效果 */
}

.info-Top{
  color: #111;
  font-size: 15px;
  font-weight: 500;
  height: 25px;
  margin-bottom: 13px;
}

.webBox{
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  display: -webkit-box;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-all;
}

/deep/ .el-dialog {
  margin-top: 30vh !important;
}
</style>